<template>
  <CFooter>
    <div>
      <span class="ms-1">&copy; {{ new Date().getFullYear() }} HUB.</span>
    </div>
    <div class="ms-auto">
      v{{ $store.getters.appVersion }}
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'AppFooter',
}
</script>
